export default {"src":"/_next/static/media/linkedin.4fc9897a.svg","height":40,"width":40};